export default {
    yAxis: {
        plotBands: [
            {
                label: {
                    align: 'right',
                    x: -10
                }
            },
            {
                label: {
                    align: 'right',
                    x: -10
                }
            }
        ]
    }
};



// WEBPACK FOOTER //
// ./app/services/charting/presets/proximity-full.js